import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TablePaginationActions from "../TablePagination";
import { connect } from "react-redux";

const styles = (theme) => ({
  cell: {
    border: "none",
    paddingTop: 20,
    paddingBottom: 20,
  },
  aside: {
    lineHeight: "40px",
  },
  roundBtn: {
    height: 40,
    width: 40,
    boxShadow: "none",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  url: {
    wordBreak: "break-all",
  },
});

export const formatDate = (date) => {
  const myDate = new Date(date);
  const monthNames = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const zeropad = (s) => `0${s}`.slice(-2);
  const hh = zeropad(myDate.getHours());
  const mm = zeropad(myDate.getMinutes());
  const day = myDate.getDate();
  const month = myDate.getMonth();
  const year = myDate.getFullYear();
  return `${day}\xa0${monthNames[month]} ${year} ${hh}:${mm}`;
};

function sortDonations(donations: any[], sortOrder: "asc" | "desc") {
  const direction = sortOrder === "asc" ? 1 : -1;
  return donations.sort((a, b) => {
    const diff =
      new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    return diff * direction;
  });
}

class DonationsTableView extends React.Component {
  constructor(props) {
    super(props);

    // default sort most recent time first
    const default_sort = "desc";

    this.state = {
      page: 0,
      rowsPerPage: 6,
      open: false,
      sort: default_sort,
      donationsArr: sortDonations(
        Object.keys(props.donations || {}).map((key) => ({
          key,
          ...props.donations[key],
        })),
        default_sort
      ),
      isSorting: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.donations === undefined &&
      this.props.donations !== undefined &&
      JSON.stringify(this.props.donations) !== JSON.stringify({}) &&
      this.state.donationsArr.length === 0
    ) {
      const donationsArr = Object.keys(props.donations || {}).map((key) => {
        return { key, ...props.donations[key] };
      });

      this.setState({ donationsArr });
    }
  }

  componentWillReceiveProps(nextProps) {
    const donations = Object.keys(nextProps.donations || {}).map((key) => {
      return { key, ...nextProps.donations[key] };
    });

    const { sort } = this.state;
    if (this.state.isSorting) {
      sortDonations(donations, sort === "asc" ? "desc" : "asc");
      this.setState((prevState) => ({ donationsArr: donations }));
    } else {
      this.setState((prevState) => ({ donationsArr: donations }));
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  sortData = () => {
    const { sort, donationsArr } = this.state;
    const newSort = sort === "asc" ? "desc" : "asc";
    sortDonations(donationsArr, newSort);
    this.setState((prevState) => ({
      sort: newSort,
      isSorting: !prevState.isSorting,
    }));
  };

  //  Handle Open and close Dialog
  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, donations, is_fetching } = this.props;
    const { rowsPerPage, page, sort, donationsArr } = this.state;
    const uids = Object.keys(donations || {});
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, uids.length - page * rowsPerPage);
    return (
      <Table padding="checkbox">
        <TableHead>
          <TableRow>
            <TableCell sortDirection={sort}>
              <TableSortLabel
                active={true}
                direction={sort}
                onClick={this.sortData}
              >
                <Typography variant="title">DATE</Typography>
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <Typography variant="title">AMOUNT</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">TYPE</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">
                PAYMENT <br /> PLATFORM{" "}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">
                MONTHLY/
                <br />
                ONE-OFF
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">URL</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">EMAIL ADDRESS</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">GIFT AID</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="title">OPTED IN</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {donationsArr &&
            donationsArr.length > 0 &&
            donationsArr
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((donation, index) => {
                let amount =
                  donation && donation.amount ? donation.amount : "£0";
                amount = parseFloat(amount.replace("£", ""));
                const timeStamp =
                  donation && donation.timestamp
                    ? formatDate(donation.timestamp)
                    : null;
                const campaignType = donation && donation.campaignType;
                const personalDetails = donation && donation.personalDetails;
                const customer = donation && donation.customer;
                const isPetition =
                  donation && donation.campaignType === "petition";
                return (
                  <TableRow key={index}>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {timeStamp}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {isPetition ? "" : `£ ${amount}`}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {campaignType || "donation"}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {
                          // payment platform
                          isPetition
                            ? ""
                            : donation &&
                              ({ paypal: "PayPal", stripe: "Stripe" }[
                                donation.payment_type
                              ] ||
                                "Stripe")
                        }
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {
                          // Monthly/one-off
                          isPetition
                            ? ""
                            : (donation && donation.type) || "donation"
                        }
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        <span className={classes.url}>
                          {(donation && donation.url) || ""}
                        </span>
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {(donation && donation.email) ||
                          (personalDetails && personalDetails.email) ||
                          (customer &&
                            customer.personalDetails &&
                            customer.personalDetails.email)}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {isPetition
                          ? ""
                          : donation &&
                            donation.giftAidInfo &&
                            typeof donation.giftAidInfo !== "string"
                          ? "YES"
                          : "NO"}
                      </Typography>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      <Typography variant="body2" className={classes.aside}>
                        {(donation && donation.hasOptedForEmailUpdates) ||
                        (personalDetails &&
                          personalDetails.hasOptedForEmailUpdates) ||
                        (customer &&
                          customer.personalDetails &&
                          customer.personalDetails.hasOptedForEmailUpdates)
                          ? "YES"
                          : "NO"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
          {emptyRows > 0 && (
            <TableRow style={{ height: 60 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={14}
              count={uids.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handleChangePage}
              ActionsComponent={TablePaginationActions}
              rowsPerPageOptions={[]}
            />
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({});

const DonationsTable = withStyles(styles)(
  connect(
    ({ paypal }: any) => ({
      is_fetching: paypal.is_fetching,
    }),
    mapDispatchToProps
  )(DonationsTableView)
);

export default DonationsTable;
